import { g as n } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  name: "DtIconThumbsDown",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], p = ["id"];
function h(e, t, r, _, v, i) {
  return d(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--thumbs-down"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Thumbs Down",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M3.25 1.5a.5.5 0 0 0-.48.36l-1.165 4a.5.5 0 0 0 .48.64H5a.5.5 0 0 1 .486.618l-.5 2.06v.002a1.065 1.065 0 0 0 .728 1.275l1.563-3.123A1.503 1.503 0 0 1 8 6.634V1.5H3.25Zm0-1a1.5 1.5 0 0 0-1.44 1.08l-1.165 4a1.5 1.5 0 0 0 1.44 1.92h2.28l-.35 1.44v.001A2.065 2.065 0 0 0 5.993 11.5a.5.5 0 0 0 .453-.276l1.725-3.445v-.002A.5.5 0 0 1 8.62 7.5H10A1.5 1.5 0 0 0 11.5 6V2A1.5 1.5 0 0 0 10 .5H3.25ZM9 1.5v5h1a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H9Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, c);
}
const H = /* @__PURE__ */ u(m, [["render", h]]);
export {
  H as default
};
//# sourceMappingURL=thumbs-down.js.map
